import React from 'react';
import Loading from '../shared/Loading/Loading';
import Select from 'react-select';
import { InputActionMeta } from 'react-select';
import imageRou from '../../assets/icono2.png';
const customStyles = {
    option: (provided: any, state: any) => ({
        ...provided,
        padding: 4,
        fontSize: 12,
    }),
    multiValue: (base: any, state: any) => {
        return { ...base, fontSize: 11 };
    },
    singleValue: (provided: any, state: any) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition, fontSize: 14};
    }
};

const NotFoundPage: React.FC = () => {

    return (
    
        <div className="container-fluid d-flex justify-content-center align-content-center" >
             <img style={{height:200,width:200}} className='img-blink'  src='Logo-Insight-1.svg' alt='eo' ></img>

      </div>
    )
}

export default NotFoundPage;